module.exports = __webpack_public_path__ + "img/jcb_white.c3b04e17.svg";